import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import { ProgressBar } from "react-loader-spinner";

import { Form } from "react-bootstrap";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import FooterCertificateForPrint from "../../../../components/AdministrativeProcedures/printCertificates/FooterCertificateForPrint/FooterCertificateForPrint";
import InformationAboutExistingCertificate from "../../../../components/AdministrativeProcedures/commonComponents/informationAboutExistingCertificate/InformationAboutExistingCertificate";
import InterestedPersonIssuingCertificatesInfo from "../../../../components/AdministrativeProcedures/commonComponents/interestedPersonIssuingCertificatesInfo/InterestedPersonIssuingCertificatesInfo";
import NotificationWindow from "../../../../components/GeneralComponents/NotificationWindow/NotificationWindow";
import {
  checkBoxForFooter,
  getOptionsForInputs,
  setOptionsForInputs,
} from "./optionsForCertificateCardPrint";
import {
  setDocOptionsInterestedFromDictionaries,
  setupOptionsInterestedPersonByCertificateType,
} from "../../../../components/AdministrativeProcedures/commonComponents/interestedPersonIssuingCertificatesInfo/optionsinterestedPersonIssuingCertificates";

import {
  API_GET_DATA_FOR_CARD_PRINT_CERTIFICATES,
  API_SAVE_DATA_AFTER_EDIT_LICENSENUM_CARD_PRINT_CERTIFICATES,
  API_SAVE_DATA_AFTER_VIEW_CARD_PRINT_CERTIFICATES,
  MAIN_URL,
  PORT,
} from "../../../../constants/constants";

import styles from "./CertificateCardForPrint.module.css";

function CertificateCardForPrint() {
  const location = useLocation();
  const navigate = useNavigate();
  const { data, mode } = location.state || {};
  const [inputOptions, setInputOptions] = useState(getOptionsForInputs());
  const [errors, setErrors] = useState({});
  const [cardData, setCardData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [showNotificationWindow, setShowNotificationWindow] = useState(false);
  const [messageNotificationWindow, setMessageNotificationWindow] = useState("");
  const [settings, setSettings] = useState({
    header: "",
  });
  const dictionaryReducer = useSelector((state) => {
    const { dictionaryReducer } = state;
    return dictionaryReducer;
  });

  const handlerUpdateData = (e) => {
    let newData = {};
    if (e.hasOwnProperty("target")) {
      switch (e.target.type) {
        case "date": {
          if (e.target.id !== "dateOfBirth") {
            const originalDateStr = e.target.value;
            const [year, month, day] = originalDateStr.split("-").map(Number);
            const newYear = year + 10;
            const newDate = new Date(newYear, month - 1, day);
            newDate.setDate(newDate.getDate() - 1);
            const formattedNewDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(
              2,
              "0",
            )}-${String(newDate.getDate()).padStart(2, "0")}`;
            newData.dateOfIssueOfCertificate = originalDateStr;
            newData.validUntil = formattedNewDate;
          } else {
            newData[e.target.id] = e.target.value;
          }

          break;
        }
        case "checkbox": {
          const valueForData = e.target.checked ? 1 : 0;
          newData = { [e.target.id]: valueForData };
          break;
        }
        case "text": {
          const valueForData = e.target.value;
          newData = { [e.target.id]: valueForData };
          break;
        }
        case "textarea": {
          const valueForData = e.target.value;
          newData = { [e.target.id]: valueForData };
          break;
        }
        default: {
          break;
        }
      }
    } else {
      newData = { [e.key]: e.value };
    }

    setCardData({ ...cardData, ...newData });
  };
  const handleErrors = () => {
    const newErrors = {};

    Object.values(inputOptions.footer).forEach((field) => {
      const value = cardData[field.key];

      if (field.required && !value) {
        newErrors[field.key] = "Заполните поле";
        return;
      }

      if (field.pattern && value && !field.pattern.value.test(value)) {
        newErrors[field.key] = field.pattern.message;
        return;
      }

      if (field.customValidation && value && field.type === "date") {
        const validationError = field.customValidation(value, cardData);
        if (validationError) {
          newErrors[field.key] = validationError;
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleButtonClick = async (e) => {
    switch (e.target.id) {
      case "add": {
        if (handleErrors()) {
          let jsonForBody = "";
          let response = null;
          if (mode === "view") {
            jsonForBody = JSON.stringify(cardData);
            response = await fetchWithToken(
              MAIN_URL +
                PORT +
                API_SAVE_DATA_AFTER_VIEW_CARD_PRINT_CERTIFICATES +
                `${data.vrowid}/` +
                `${data.licenseTypeId}/` +
                `${data.appType}`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: jsonForBody,
              },
            );
          }
          if (mode === "edit") {
            response = await fetchWithToken(
              MAIN_URL +
                PORT +
                API_SAVE_DATA_AFTER_EDIT_LICENSENUM_CARD_PRINT_CERTIFICATES +
                `?appIds=${data.vrowid}&statusId=${data.statusId}&newLicenseNum=${cardData.newLicenseNum}`,
              {
                method: "POST",
              },
            );
          }

          if (response.status !== 200) {
            const responseData = await response.text();
            setMessageNotificationWindow(responseData);
            setShowNotificationWindow(!showNotificationWindow);
          } else {
            const responseData = await response.text();
            setMessageNotificationWindow(responseData);
            setShowNotificationWindow(!showNotificationWindow);
          }
        }

        break;
      }
      case "close": {
        navigate("/print-certificates");
        break;
      }
      default:
    }
  };
  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(
        MAIN_URL +
          PORT +
          API_GET_DATA_FOR_CARD_PRINT_CERTIFICATES +
          `${data.vrowid}/` +
          `${data.licenseTypeId}/` +
          `${data.appType}`,
      );
      if (response.status !== 200) {
        const responseData = await response.text();
        setMessageNotificationWindow(responseData);
        setShowNotificationWindow(!showNotificationWindow);
        setIsLoading(false);
      } else {
        const responseData = await response.json();
        setCardData(responseData);
        setIsLoading(false);
        if (data.licenseTypeId === 1) {
          settings.header =
            "О выдаче удостоверения на право управления моторным маломерным судном, мощность которого превышает 3,7 килловатта (5 лошадиных сил)";
          setSettings({ ...settings });
          await setupOptionsInterestedPersonByCertificateType(data.licenseTypeId);
        } else {
          settings.header = "О выдаче международного удостоверения на право управления прогулочным судном";
          setSettings({ ...settings });
          await setupOptionsInterestedPersonByCertificateType(data.licenseTypeId);
        }
      }
    }
    fetchData();
  }, []);
  useEffect(() => {
    if (mode === "view") {
      setOptionsForInputs("view", {}, data.licenseTypeId);
    } else {
      setOptionsForInputs("edit", {}, data.licenseTypeId);
    }
  }, []);
  useEffect(() => {
    if (dictionaryReducer.allMedConditions.length > 0) {
      setOptionsForInputs("med", dictionaryReducer.allMedConditions);
    }
    if (Object.values(dictionaryReducer.identificationDocuments).length > 0) {
      setDocOptionsInterestedFromDictionaries(dictionaryReducer.identificationDocuments);
    }
    setInputOptions(getOptionsForInputs());
  }, [dictionaryReducer]);

  if (isLoading) {
    return (
      <div className={"d-flex flex-column align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }

  return (
    <div className={styles["content-container"]}>
      <h1 className={styles["main-text"]}>Заявление</h1>
      <p className={styles["description-text"]}>{settings.header}</p>
      <Form className={styles["form-container"]}>
        <div>
          {Object.values(inputOptions.header).map((option) => {
            return (
              <div
                key={option.key}
                className={styles["text-block"]}>
                <p className={styles["option-label"]}>{option.value}</p>
                <p className={styles["option-value"]}>
                  {option.type === "selectWithSearch"
                    ? option.options.find((elem) => elem.value === cardData?.[option.key])?.label || "—"
                    : option.type === "date" && cardData?.[option.key]
                    ? cardData?.[option.key].split("-").reverse().join(".")
                    : cardData?.[option.key] || "—"}
                </p>
              </div>
            );
          })}
        </div>
        <InterestedPersonIssuingCertificatesInfo
          inputData={cardData}
          certificateType={cardData?.licenseType}
          mode={"view"}
          fieldsOptions={inputOptions.person}
        />
        {cardData?.licenseType === 2 && (
          <InformationAboutExistingCertificate
            mode={"view"}
            fieldsOptions={inputOptions.infoExistingCertification}
            inputData={cardData}
          />
        )}
        {/*<MedicalConditionsIssuingCertificates*/}
        {/*  mode={"view"}*/}
        {/*  inputData={cardData}*/}
        {/*/>*/}
        <FooterCertificateForPrint
          mode={mode}
          errors={errors}
          inputs={inputOptions.footer}
          checkBoxInputs={cardData?.licenseType === 2 && mode === "view" ? checkBoxForFooter : null}
          data={cardData}
          handlerUpdateData={handlerUpdateData}
        />
      </Form>
      <div className={styles["buttons-container"]}>
        <div
          className={`${styles["add-button"]}`}
          id={"add"}
          onClick={(e) => handleButtonClick(e)}>
          Сохранить
        </div>
        <div
          className={styles["close-button"]}
          id={"close"}
          onClick={(e) => handleButtonClick(e)}>
          Закрыть
        </div>
      </div>
      <NotificationWindow
        isError={showNotificationWindow}
        show={showNotificationWindow}
        setShow={setShowNotificationWindow}
        headerText={"Уведомление"}
        messageText={messageNotificationWindow}
        onClose={() => navigate("/print-certificates")}
      />
    </div>
  );
}

export default CertificateCardForPrint;
